<template>
  <v-container>
    <v-app-bar dark app color="primary">
      <v-btn icon>
        <v-icon>mdi-cogs</v-icon>
      </v-btn>
      <v-toolbar-title>Automatisierung</v-toolbar-title>
      <v-spacer />
      <v-text-field
        class="mr-2"
        v-model="search"
        append-icon="mdi-magnify"
        label="Suche"
        single-line
        hide-details
        clearable
        id="search"
      ></v-text-field>

      <template v-slot:extension>
        <v-tabs align-with-title>
          <v-tabs-slider color="error"></v-tabs-slider>
          <v-tab exact :to="{ name: 'AutomationJobs' }">
            <v-badge
              color="danger"
              :value="overview && overview.errors"
              :content="overview.errors"
              >Übersicht</v-badge
            >
          </v-tab>
          <v-tab :to="{ name: 'AutomationChanges' }">
            <v-badge
              color="error"
              :value="overview && overview.manualChanges"
              :content="overview.manualChanges"
              >Bestätigung</v-badge
            >
          </v-tab>
          <v-tab :to="{ name: 'AutomationChangeLog' }"> Verlauf </v-tab>
          <v-tab :to="{ name: 'AutomationTasks' }">
            <v-badge
              color="info"
              :value="overview && overview.manualTasks"
              :content="overview.manualTasks"
              >Aufgaben</v-badge
            >
          </v-tab>
        </v-tabs>
      </template>
    </v-app-bar>

    <router-view :search="search" @update="fetchData"></router-view>
  </v-container>
</template>

<script>
import { defineComponent } from "vue";
export default defineComponent({
  name: "Automation",

  data() {
    return {
      search: null,
      overview: {},
    };
  },
  methods: {
    async fetchData() {
      this.overview = await this.apiList({
        resource: "automation/overview",
      });
    },
  },
  created() {
    this.fetchData();
  },
});
</script>
